import { PRestartLogo } from '@/assets/branding/project-restart';

export default {
  name: 'Project Restart',
  isSAML: true,
  allowPersonalCourses: false,
  logo: PRestartLogo,
  colors: {
    // Brand colors
    brand_primary: '#FF0000',
    brand_primary_hover: '#CC0000',
    brand_primary_highlight: '#FFB3B3',
    brand_primary_mid: '#FF4D4D',
    brand_primary_dark: '#660000',
    brand_secondary: '#C62828',
  },
};
